"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../../assets/styles/config");
const Container = styled_components_1.default.div `
  margin-top: 12px;
`;
const loaderWidth = 200;
const Background = styled_components_1.default.div `
  position: absolute;
  width: ${loaderWidth}px;
  border-radius: 8px;
  height: 4px;
  background: ${config_1.colors.huron};
  left: 50%;
  transform: translateX(-50%);
`;
const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
const calculateLoaderWidth = ({ progress }) => {
    const pixels = loaderWidth / (100 / progress);
    const fivePercent = loaderWidth * 0.05;
    return clamp(pixels, fivePercent, loaderWidth) + 'px'; // ensure we show at least a little bit, even if the upload hasn't happened yet
};
const Indicator = (0, styled_components_1.default)(Background) `
  width: ${calculateLoaderWidth};
  background: ${config_1.colors.blurple};

  transition: width 1s ease-in-out;
`;
const UploadIndicator = ({ progress }) => {
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Background, null),
        react_1.default.createElement(Indicator, { progress: progress })));
};
exports.default = UploadIndicator;
